import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const headers = { 'Content-Type': 'application/json' };
const base = `${API_BASE_URL}/Purchase`;

const handle = (err) => {
    if (err.response?.data) throw err.response.data;
    throw err;
};

// GET cost centers the current role can post a direct stock updation from
export const getStockupdationCCs = async (UID, RID) => {
    try {
        const res = await axios.get(`${base}/StockupdationCCs`, {
            params: { UID, RID },
            headers,
        });
        return res.data;
    } catch (err) { handle(err); }
};

// GET item search categories configured for a cost center — CType is the CC code,
// despite the name (the underlying SP filters spGetIndentCategoryDetails by @CCode)
export const getIndentCategoriesDetails = async (CType) => {
    try {
        const res = await axios.get(`${base}/GetIndentcategoriesDetails`, {
            params: { CType },
            headers,
        });
        return res.data;
    } catch (err) { handle(err); }
};

// GET item-code/name prefix search for Direct Stock Updation — Typ: '1' = by code, '2' = by name
export const getAutoCompleteDirectStock = async (Pfx, Typ, Cat) => {
    try {
        const res = await axios.get(`${base}/GetAutoCompleteDirectStock`, {
            params: { Pfx, Typ, Cat },
            headers,
        });
        return res.data;
    } catch (err) { handle(err); }
};

// POST — stage one item into the direct-stock grid for a cost center
// payload: { ItemCode, Costcenter }
export const saveDirectStockItems = async (payload) => {
    try {
        const res = await axios.post(`${base}/SaveDirectStockItems`, payload, {
            headers,
            timeout: 30000,
        });
        return res.data;
    } catch (err) { handle(err); }
};

// GET the staged direct-stock items for a cost center
export const getDirectStockItemDetails = async (CCode) => {
    try {
        const res = await axios.get(`${base}/GetDirectStockItemDetails`, {
            params: { CCode },
            headers,
        });
        return res.data;
    } catch (err) { handle(err); }
};

// POST — remove one staged item from the grid
// payload: { DirectStockId }
export const deleteDirectStockItem = async (payload) => {
    try {
        const res = await axios.post(`${base}/DeleteDirectStockItem`, payload, {
            headers,
            timeout: 30000,
        });
        return res.data;
    } catch (err) { handle(err); }
};

// POST — finalize and submit the direct stock updation transaction
// payload: { DirectStockId, Quantity, Amount, BasicPrice, Costcenter, Date, Remarks, RoleID, Createdby }
export const saveDirectStock = async (payload) => {
    try {
        const res = await axios.post(`${base}/SaveDirectStock`, payload, {
            headers,
            timeout: 30000,
        });
        return res.data;
    } catch (err) { handle(err); }
};
